module.exports = __webpack_public_path__ + "15144bfc2698e71c0580e60913b6a720.svg";